import { useId, useState } from 'react';

/**
 * Hidden honeypot field for public forms. People never see or fill it; bots usually do.
 * Send `value` as `website` in the request body – the server ignores requests where it is filled.
 */
export const useHoneypot = () => {
  const [value, setValue] = useState('');
  const id = useId();
  const field = (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', width: 1, height: 1, overflow: 'hidden' }}>
      <label htmlFor={`hp-${id}`}>Website</label>
      <input
        id={`hp-${id}`}
        name="website"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
  return { value, field };
};
